var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.08,16.17s-.03,0-.05,.01l-3.77,2.01,.72-4.29c.05-.28-.04-.56-.24-.76l-3.08-3.05,4.24-.62c.28-.04,.52-.22,.65-.48l1.88-3.88,1.89,3.88c.12,.26,.37,.43,.65,.48l4.24,.62-1.59,1.58h2.44l1.58-1.57c.23-.23,.31-.57,.21-.88-.1-.31-.37-.53-.69-.58l-5.5-.81-2.46-5.06c-.14-.3-.44-.48-.77-.48s-.63,.19-.77,.48l-2.46,5.06-5.49,.81c-.32,.05-.59,.27-.69,.58-.1,.31-.02,.65,.21,.88l3.98,3.95-.97,5.57c-.02,.32,.11,.65,.38,.84,.27,.19,.62,.22,.88,.06l4.59-2.44v-1.94Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15,16.85h-7.41c-.34,0-.62,.28-.62,.62s.28,.62,.62,.62h7.41c.34,0,.62-.28,.62-.62s-.28-.62-.62-.62Zm-7.41-1.85h7.41c.34,0,.62-.28,.62-.62s-.28-.62-.62-.62h-7.41c-.34,0-.62,.28-.62,.62s.28,.62,.62,.62Zm7.41,4.94h-7.41c-.34,0-.62,.28-.62,.62s.28,.62,.62,.62h7.41c.34,0,.62-.28,.62-.62s-.28-.62-.62-.62Z",
    fill: "#f90014"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.a0a3769f6ba29a8184e3f34caf88acc3.svg";
export { ForwardRef as ReactComponent };